export default [
	{
		type: "uni",
		id: 1,
		items: [
			{
				id: 1,
				text: "The lecturer was enthusiastic and motivated.",
			},
			{
				id: 2,
				text: "I was able to follow the pace of the lecturer.",
			},
			{
				id: 3,
				text: "The lecturer provided a good learning and working atmosphere.",
			},
			{
				id: 4,
				text: "The lecturer has always been well prepared.",
			},
			{
				id: 5,
				text: "The lecturer was very competent.",
			},
			{
				id: 6,
				text: "The lecturer was able to put complicated ideas across.",
			},
			{
				id: 7,
				text: "It was important to the lecturer that the participants benefitted from the course.",
			},
			{
				id: 8,
				text: "The lecturer motivated the participants.",
			},
			{
				id: 9,
				text: "The learning objective was clear to me.",
			},
			{
				id: 10,
				text: "The educational objectives were well defined from the beginning.",
			},
			{
				id: 11,
				text: "The course was well structured and comprehensible.",
			},
			{
				id: 12,
				text: "The structure of the content was logical/easy to follow.",
			},
			{
				id: 13,
				text: "I was already interested in the subject of the course before I signed up for it.",
			},
			{
				id: 14,
				text: "I believe that I have learned important facts in this course.",
			},
			{
				id: 15,
				text: "The topic of the course is relevant.",
			},
		],
	},
	{
		type: "bi",
		id: 2,
		items: [
			{
				id: 16,
				text: "The difficulty of the content was...",
			},
			{
				id: 17,
				text: "The amount of the content was...",
			},
			{
				id: 18,
				text: "The requirements of the course were...",
			},
			{
				id: 19,
				text: "The amount of time required for the course (including preparation and follow-up) was...",
			},
			{
				id: 20,
				text: "Overall, I felt the course to be...",
			},
		],
	},
	{
		type: "uni",
		id: 3,
		items: [
			{
				id: 21,
				text: "During the preparation of the oral presentation the lecturer’s support, if demanded, was very helpful.",
			},
			{
				id: 22,
				text: "The lecturer was able to add information to oral presentations in a proper way.",
			},
			{
				id: 23,
				text: "The questions posed by the lecturer during the oral presentations were productive.",
			},
			{
				id: 24,
				text: "The presentation style of oral presentations was appealing.",
			},
			{
				id: 25,
				text: "The content of oral presentations was of high quality.",
			},
			{
				id: 26,
				text: "The oral presentations given by other participants have been very informative.",
			},
			{
				id: 27,
				text: "Concerning the organizational aspects of the course (i.e. place, time, performance requirements) I was informed well.",
			},
			{
				id: 28,
				text: "I was satisfied with the accessibility of necessary learning material.",
			},
			{
				id: 29,
				text: "Organizational issues were dealt with in time and in detail.",
			},
			{
				id: 30,
				text: "The course was running smoothly during the semester.",
			},
			{
				id: 31,
				text: "Altogether, the course was well organized.",
			},
			{
				id: 32,
				text: "There was ample opportunity for interaction with the lecturer through the online tools.",
			},
			{
				id: 33,
				text: "There was ample opportunity for interaction with the other students through the online tools.",
			},
			{
				id: 34,
				text: "The online appointments were well organized.",
			},
			{
				id: 35,
				text: "The online materials (e.g. texts, quizzes, videos, etc.) contributed significantly to the understanding of the learning content.",
			},
			{
				id: 36,
				text: "The possibilities of digital teaching beyond traditional teaching (discussion forums, interactive assignments, etc.) were well used.",
			},
			{
				id: 37,
				text: "Overall, the digital elements of the event were good.",
			},
			{
				id: 38,
				text: "The course is an example of good digital education.",
			},
			{
				id: 39,
				text: "Overall, this was a good course.",
			},
			{
				id: 40,
				text: "I learned a lot in this course.",
			},
			{
				id: 41,
				text: "The course fulfilled my expectations.",
			},
			{
				id: 42,
				text: "I would recommend the course.",
			},
			{
				id: 43,
				text: "In terms of its quality, this course was as good as the best course I have ever attended.",
			},
		],
	},
	{
		type: "text",
		id: 4,
		items: [
			{
				id: 44,
				text: "I especially appreciated:",
			},
			{
				id: 45,
				text: "I did not like:",
			},
			{
				id: 46,
				text: "Suggestions for improvements:",
			},
		],
	},
];
